import React, { useEffect, useState } from "react";

import {
  Button,
  Col,
  Row,
  Table,
  Input,
  Form,
  Popconfirm,
  Tooltip,
  Space,
  message,
  Radio,
} from "antd";
import IMAGES from "../const/Image";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useNavigate, useSearchParams } from "react-router-dom";
import NotificationService from "../Services/NotificationService";

const initialFilter = {
  page: 1,
};

function ViewAllNotification() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [selectionType, setSelectionType] = useState("checkbox");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const rowSelection = {
    type: selectionType,
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      console.log(
        `selectedRowKeys : ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
  };

  const handleDeleteSelected = () => {
    if (selectedRowKeys.length === 0) {
      message.warning("Please select at least one notification to delete.");
      return;
    }

    setLoading(true);
    const deletePromises = selectedRowKeys.map((id) =>
      NotificationService.deleteNotification(id).catch((error) => {
        console.error(`Failed to delete notification with ID ${id}:`, error);
        return null;
      })
    );

    Promise.all(deletePromises)
      .then(() => {
        setNotifications((prevList) =>
          prevList.filter((item) => !selectedRowKeys.includes(item.id))
        );
        setSelectedRowKeys([]);
        message.success("Selected notifications deleted successfully");
      })
      .catch((error) => {
        message.error("Failed to delete some notifications");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const notificationList = [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      width: "60px",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Salon Name",
      dataIndex: "salonName",
      key: "salonName",
    },
    {
      title: "Owner Name",
      dataIndex: "ownerName",
      key: "ownerName",
    },
    // {
    //   title: "Image",
    //   dataIndex: "profileImage",
    //   key: "profileImage",

    //   render: (text) => (
    //     <img
    //       src={text || IMAGES.PlaceholderImage}
    //       alt="profile image"
    //       style={{ width: "100%", height: "66px" }}
    //     />
    //   ),
    // },

    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },

    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",

      render: (createdAt) => dayjs(createdAt).format("MMMM D, YYYY h:mm:ss A"),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Popconfirm
            title="Delete this category?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <span className="action-icon-bg">
              <img src={IMAGES.DeleteIcon} alt="Delete" />
            </span>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleDelete = (id) => {
    setLoading(true);
    NotificationService.deleteNotification(id)
      .then(() => {
        setNotifications((prevList) =>
          prevList.filter((item) => item.id !== id)
        );
        navigate(0, { state: { refresh: true } });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const handleFilter = (value) => {
  //   setFilter({ ...filter, ...filterForm, ...initialFilter })
  //   console.log('filter', filter)
  //   setIsModalOpen(false)
  // }
  
    const handleChange = (pagination) => {
    setFilter((prev) => ({
      ...prev,
      page: pagination.current, // Update current page from pagination event
    }));
  };
  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  const fetchNotificationList = (id) => {
    setLoading(true);
    NotificationService.notificationList(id , filter)
      .then((response) => {
        const rawData = response?.data?.data?.notificationData || [];
        const totalCount = response?.data?.data?.totalCounts || 0;
        setNotifications(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchNotificationList(id);
  }, [id , filter]);

  //  const handleFilter = (value) => {
  //   setFilter({ ...filter, ...filterForm, ...initialFilter })
  //   console.log('filter', filter)
  //   setIsModalOpen(false)
  // }

  return (
    <div>
      <Row gutter={[8, 8]} justify="space-between" align="middle">
        <Col>
          <h1 className="app-heading-med"> Notifications</h1>
        </Col>
        <Col>
          <div style={{ display: "flex", gap: "1rem" }}>
            {/* <Input
              placeholder="Search by title"
              size="large"
              className="FilterSearchBox"
              onChange={(e) => setFilterForm({ ...filterForm, search: e.target.value })}
              value={filterForm?.search}

              style={{ width: "100%" }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleFilter();
                }
              }}

            /> */}
            <Button
              onClick={handleDeleteSelected}
              type="primary"
              htmlType="submit"
              className="addcity-btn"
              style={{ height: "39px" }}
              // disabled={selectedRowKeys.length === 0} // Disable if no rows are selected
            >
              Delete Selected
            </Button>
            {/* <Button

              type="primary"
              className="addcity-btn"
              onClick={resetFilters}
              style={{ height: "39px" }}
            >
              Reset
            </Button> */}
          </div>
        </Col>
      </Row>

      <div className="mt-5">
        <Radio.Group
          onChange={(e) => setSelectionType(e.target.value)}
          value={selectionType}
        ></Radio.Group>

        <Table
          rowSelection={rowSelection}
          size="middle"
          bordered
          columns={notificationList}
          loading={loading}
          // rowKey={(record) => record.id}
          onChange={handleChange}
          dataSource={notifications}
          rowKey="id"
          // pagination={{
          //   total: totalRecords,
          //   current: filter?.page || 1,
          //   defaultCurrent: 1,
          // }}

          pagination={{
            total: totalRecords, // Total items from API
            current: filter?.page, // Current page from API
            pageSize: 10, // Keep it fixed to 10 as per API request
            showSizeChanger: false, // Disable changing page size
          
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
            onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
          }}
        />
      </div>
    </div>
  );
}

export default ViewAllNotification;
